import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'hb-text-modal-title',
  templateUrl: './modal-title.component.html',
  styleUrls: ['./modal-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextModalTitleComponent {
  @Input() text: string;
}
